// extracted by mini-css-extract-plugin
module.exports = {"heading":"LandownerReferralPage_heading__2j9eB","content":"LandownerReferralPage_content__1Pdrn"};